<div *ngIf="isDraft !== undefined && ready" id="fullScreen">
  <div style="align-items: center;" class="mt-2 flex flex-row justify-between">
    <div style="align-items: center;" class="mt-2 flex flex-row">
      <dx-lookup
        [disabled]="!isDraft"
        [width]="616"
        [label]="'Routing' | translate | ucfirst"
        [gsResource]="routings"
        [(value)]="routingId"
        displayExpr="name"
        [showClearButton]="false"
        itemTemplate="Routing"
        fieldTemplate="Routing"
        (onSelectionChanged)="onRoutingChange($event)"
        valueExpr="id">
        <div *dxTemplate="let routing of 'Routing'">
          <div *ngIf="routing">
            <div style="white-space: normal" >{{ routing.code }} | {{ routing.name }}</div>
            <div style="white-space: normal" > {{'entity.bom.version' | translate| ucfirst}}: {{ routing.version }}</div>
          </div>
        </div>
      </dx-lookup>
        <dx-button [style.color]="!isDraft ? '#c6c6c6' : null" [disabled]="!isDraft" hint="add routing" icon="add" class="mb-3 m-1"
                   (click)="addRouting()"/>
        <dx-button  hint="copy routing" icon="copy" class="mb-3 m-1"
        [disabled]="!routingId || !isDraft"
        (click)="copyRouting()"/>
        <dx-button  [hint]="'entity.processSheet.links' | translate | ucfirst" icon="bulletlist" class="mb-3 m-1"
        [disabled]="!routingId"
        (click)="openRevisions()"/>
        <div
        *ngIf="routing"
        class="px-3 py-1 rounded-full text-white text-center mb-3 ml-1"
        [style]="{backgroundColor: stateColors[routing!.stateId]}"
        title="{{ states[routing!.stateId] | ucfirst }}"
      >{{ states[routing!.stateId] | ucfirst }}</div>
    </div>
    <div class="flex flex-row">
      <dx-button [style.color]="(!routingId || !isDraft || routing!.stateId === draftableActive) ? '#c6c6c6' : null" [disabled]="!routingId || !isDraft || routing!.stateId === draftableActive" hint="add operation" icon="add" class="mb-3"
      (click)="addOperation()"/>
      <dx-button  icon="open_with" (click)="toggleFullscreen()"></dx-button>
    </div>
  </div>
  <div  class="mt-2">
    <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#scheduler' }"
    [(visible)]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
    >
    </dx-load-panel>
    <div *ngIf="!loadingVisible">
      <div *ngIf="routingOperations  && routingOperations.length > 0; else noOperations" class="mt-2 space-y-4">
        <dx-sortable
            [data]="routingOperations"
            itemOrientation="vertical"
            (onReorder)="onReorder($event)"
          >
        <ng-container *ngFor="let operation of routingOperations">
          <div class="shadow p-4 border mt-2 mb-2">
            <!-- operation and workprocedure -->
              <div class="flex flex-col">
                <div class="flex flex-row justify-between w-full">
                  <div
                    (click)="routing!.stateId !== draftableActive && openOperationEditor(operation)"
                    class="font-bold text-lg"
                    [class.hover:underline]="routing!.stateId !== draftableActive"
                    [class.cursor-pointer]="routing!.stateId !== draftableActive"
                  >
                    {{ operation.name }}
                  </div>
                  <dx-button [disabled]="!routingId || !isDraft || routing!.stateId === draftableActive" hint="delete" stylingMode="text" type="danger"  icon="delete"
                  (click)="routing!.stateId !== draftableActive && deleteOperation(operation)"/>
                </div>
                <div
                  *ngIf="operation.workProcedure"
                  class="p-4 shadow mb-3 bg" style="box-shadow: 0 0 4px rgb(0 0 0 / 32%); background-color: #80808021;"
                >
                  {{ operation.workProcedure.code }} {{ operation.workProcedure.name }} - {{ 'common.version' | translate }}: {{ operation.workProcedure.version }}
                  <!-- Steps -->
                  <div  *ngIf="operation.steps && operation.steps.length > 0; else noSteps">
                    <div *ngFor="let step of operation.steps">
                      <div class="flex flex-row justify-between gap-2">
                        <span class="font-medium">{{ step.order }}. {{ step.instructionsFormatted }}</span>
                        <span *ngIf="step.defaultValues.length" class="ml-2 text-gray-500 whitespace-normal">{{ step.defaultValues.join(', ') }}</span>
                      </div>
                    </div>
                  </div>
                  <ng-template #noSteps>
                    <p class="text-gray-400 text-sm">{{ 'entity.processSheet.stepsNotAvailable' | translate }}</p>
                  </ng-template>
                </div>
              </div>

            <!-- resource allocations -->
            <div class="p-4 mt-2 shadow" style="box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);" *ngIf="operation.resourceAllocations && operation.resourceAllocations.length > 0; else noResources">
              <div *ngFor="let alloc of operation.resourceAllocations" class="">
                <div class="flex flex-row mt-2 mb-2">
                  <div class="flex items-start flex-row">
                    <span [icon]="'schedule'" size="0.5rem" class="mr-3 mt-1"></span>
                    <div class="flex flex-col justify-start gap-1 w-40">
                      <div>{{ 'entity.maintenancePlans.cycle' | translate }} {{ alloc.cycleQuantity }}</div>
                      <div>{{ alloc.setup }}</div>
                      <div>{{ alloc.process }}</div>
                      <div>{{ alloc.teardown }}</div>
                    </div>
                  </div>
                  <div *ngIf="alloc.workCenters && alloc.workCenters.length > 0" class="flex items-start flex-row">
                    <span [icon]="'precision_manufacturing'" size="0.5rem" class="mr-3 mt-1"></span>
                    <div class="flex flex-col justify-start gap-1 w-40">
                      <div *ngFor="let section of alloc.workCenters">
                        <div class="font-bold">{{ section.sectionName }}</div>
                        <div class="ml-2">
                          <div *ngFor="let wc of section.workCenters">
                            {{ wc.workCenterName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="alloc.equipments && alloc.equipments.length > 0" class="flex items-start flex-row">
                    <span [icon]="'settings'" size="0.5rem" class="mr-3 mt-1"></span>
                    <div class="flex flex-col justify-start gap-1 w-40">
                      <div *ngFor="let equipments of alloc.equipments">
                        <div>{{ equipments.equipmentName }} {{ equipments.quantity }}</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="alloc.toolings && alloc.toolings.length > 0"v class="flex items-start flex-row">
                    <span [icon]="'build'" size="0.5rem" class="mr-3 mt-1"></span>
                    <div class="flex flex-col justify-start gap-1 w-40">
                      <div *ngFor="let tooling of alloc.toolings">
                        {{ tooling.toolingName }} ({{ tooling.quantity }})
                      </div>
                    </div>
                  </div>
                  <div *ngIf="alloc.workforces && alloc.workforces.length > 0" class="flex items-start flex-row">
                    <span [icon]="'engineering'" size="0.5rem" class="mr-3 mt-1"></span>
                    <div class="flex flex-col justify-start gap-1 w-40">
                      <div *ngFor="let workforces of alloc.workforces">
                        {{ workforces.workforceName}} ({{ workforces.occupation * 100 }}%)
                      </div>
                    </div>
                  </div>
                  <div *ngIf="alloc.workers && alloc.workers.length > 0" class="flex items-start flex-row">
                    <span [icon]="'engineering'" size="0.5rem" class="mr-3 mt-1"></span>
                    <div class="flex flex-col justify-start gap-1 w-40">
                      <div *ngFor="let workers of alloc.workers">
                        <div>{{ workers.workerName }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noResources>
              <p class="text-gray-400 text-sm">{{ 'No resource allocations available' | translate }}</p>
            </ng-template>
            <div *ngIf="operation.dependencies && operation.dependencies.length > 0;" class="flex flex-col mt-2">
              <div class="text-sm text-gray-500">{{ 'operation.dependencies' | translate | ucfirst}}</div>
              <div  class="text-sm text-gray-500">
                  {{ getOperationNames(operation.dependencies) }}
              </div>
            </div>
          </div>
        </ng-container>
        </dx-sortable>
      </div>

      <ng-template #noOperations>
        <p class="text-gray-400 text-sm">{{ 'No operations available' | translate }}</p>
      </ng-template>
    </div>



  </div>
</div>

<gs-popup
  [(visible)]="revisionsPopupVisible"
  [title]="'entity.processSheet.links' | translate | ucfirst"
  [width]="900"
  [height]="600"
>
  <div gs-popup-tabs class="h-full flex flex-col min-h-0">
    <dx-data-grid
      *ngIf="routingRevisions"
      [glamResource]="routingRevisions"
      [editingLocked]="true"
      [remoteOperations]="{ paging: true }"
      [height]="'100%'"
    >
      <dxi-column cellTemplate="codeCellTpl" dataField="code" [caption]="'entity.processSheet.code' | translate | ucfirst">
        <div (click)="navigateToProcessSheetEditor(item.data)" class="hover:underline cursor-pointer" *dxTemplate="let item of 'codeCellTpl'">
          {{item.data.code}}
        </div>
      </dxi-column>
      <dxi-column cellTemplate="nameCellTpl" dataField="name" [caption]="'entity.processSheet.processSheet' | translate | ucfirst">
        <div (click)="navigateToProcessSheetEditor(item.data)" class="hover:underline cursor-pointer" *dxTemplate="let item of 'nameCellTpl'">
          {{item.data.name}}
        </div>
      </dxi-column>
      <dxi-column cellTemplate="versionNameCellTpl" dataField="versionName" [caption]="'entity.maintenancePlans.version' | translate | ucfirst">
        <div (click)="navigateToProcessSheetEditor(item.data)" class="hover:underline cursor-pointer" *dxTemplate="let item of 'versionNameCellTpl'">
          {{item.data.version}}
        </div>
      </dxi-column>
      <dxi-column cellTemplate="docTypeCellTpl" datafield="documentTypeName" [caption]="'entity.documentType.documentType' | translate | ucfirst">
        <div *dxTemplate="let item of 'docTypeCellTpl'">
          {{ item.data.documentTypeName }}
        </div>
      </dxi-column>
      <dxi-column  cellTemplate="state" dataField="revisionStateId" [caption]="'entity.appointment.stateId' | translate | ucfirst">
        <dxo-lookup [dataSource]="stateTypes" displayExpr="displayName" valueExpr="id"></dxo-lookup>
        <div *dxTemplate="let data of 'state'" class="w-min" style="min-width: 100px; text-align: center;">
          <gs-entity-state-label [resource]="processSheetRs"
                                 [entity]="data.data"
                                 class="w-min">
          </gs-entity-state-label>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</gs-popup>
